import useModalGeneric from './useModalGeneric'
import useSessionState from './useSessionState'
import useLocaleMode from './useLocaleMode'
import useHomeLinkMode from './useHomeLinkMode'
import useBrowserMode from './useBrowserMode'

export default function useModalAuth() {
	const [isModalAuth, showModalAuth, hideModalAuth] = useModalGeneric(false)
	const { isLoggedUser } = useSessionState()
	const { locale } = useLocaleMode()
	const { homeLink } = useHomeLinkMode()
	const { isBrowser } = useBrowserMode()

	const validateSamples = () => {
		if (isLoggedUser) {
			isBrowser &&
				(window.location.href =
					homeLink +
					(locale === 'es-CO'
						? 'muestra-gratis/confirmacion/'
						: 'pide-tu-muestra/confirmacion/'))
		} else {
			showModalAuth()
		}
	}

	return [isModalAuth, validateSamples, hideModalAuth]
}
